import { render, staticRenderFns } from "./ContactUs.vue?vue&type=template&id=6140fd9d&scoped=true&"
import script from "./ContactUs.vue?vue&type=script&lang=js&"
export * from "./ContactUs.vue?vue&type=script&lang=js&"
import style1 from "./ContactUs.vue?vue&type=style&index=1&id=6140fd9d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6140fd9d",
  null
  
)

export default component.exports